import api from '../../utils/api'

export const state = {
  userAwareOfInformation: [],
  userAwareOfInformationMeta: []
}

export const mutations = {
  SET_USERAWAREOF_INFORMATION(state, userAwareOfInformation) {
    state.userAwareOfInformation = userAwareOfInformation
  },
  SET_USERAWAREOF_INFORMATION_META(state, userAwareOfInformationMeta) {
    state.userAwareOfInformationMeta = userAwareOfInformationMeta
  }
}

export const actions = {
  async handleCreate(_, body) {
    try {
      return await api.post('/user-aware-information', body)
    } catch (err) {

    }
  },

  async handleGetAwareOfInformationByUser(_, userId) {
    try {
      return await api.get(`/user-aware-information/${userId}/user`)
    } catch (err) {

    }
  },

  async handlePaginatedList({ commit }, payload) {
    let params = {}
    if (payload) {
      params = {
        endDate: payload.endDate || null,
        startDate: payload.startDate || null,
        search: payload.search || null,
        skip: payload.skip || 0,
        limit: payload.limit || 10
      }
    }
    const { data: response } = await api.get(`/user-aware-information`, { params })
    console.log(response)
    if (response && response.items) {
      commit('SET_USERAWAREOF_INFORMATION', response.items)
      commit('SET_USERAWAREOF_INFORMATION_META', response.meta)
    } else {
      commit('SET_USERAWAREOF_INFORMATION', [])
      commit('SET_USERAWAREOF_INFORMATION_META', {})
    }
  },
  handleResetMeta: ({ commit }) => commit('SET_USERAWAREOF_INFORMATION_META', {
    startDate: null,
    endDate: null,
    search: null,
    limit: 10,
    skip: 0
  })
}

export const getters = {
  userAwareOfInformation: (state) => state.userAwareOfInformation,
  userAwareOfInformationMeta: (state) => state.userAwareOfInformationMeta
}
